import { render, staticRenderFns } from "./Suspended.vue?vue&type=template&id=7df4e216"
import script from "./Suspended.vue?vue&type=script&lang=js"
export * from "./Suspended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports